import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axiosInstance from '../api/axios';

export const usePermissions = () => {
  const { access_token } = useSelector((state) => state.auth);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!access_token) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await axiosInstance.get('/api/admin/moderators/permissions', {
          headers: { token: access_token }
        });
        
        if (response.data.success) {
          setPermissions(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [access_token]);

  const can = (permission) => {
    return permissions.includes(permission);
  };

  return { can, loading };
}; 